import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CustomToaster } from '../BaseUI';
import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';
import MiddleSection from './MiddleSection';

const queryClient = new QueryClient();

const CorporateLanding = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <CustomToaster />
      <HeaderSection />
      <MiddleSection />
      <FooterSection />
    </QueryClientProvider>
  );
};

export default CorporateLanding;
